import React from "react";
import { FormActions, FormField, FormGrid } from "../app";
import { Checkbox } from "../ui/checkbox";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";

export function ClientForm({ formData, setFormData, t, onSubmit, onCancel }) {
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <FormField label={t("name")} required>
        <Input
          value={formData.name}
          onChange={(event) =>
            setFormData({ ...formData, name: event.target.value })
          }
          className="valhalla-input"
          required
          data-testid="client-name"
        />
      </FormField>

      <FormField label={t("contactName")}>
        <Input
          value={formData.contact_name}
          onChange={(event) =>
            setFormData({ ...formData, contact_name: event.target.value })
          }
          className="valhalla-input"
        />
      </FormField>

      <FormField label={t("email")} required>
        <Input
          type="email"
          value={formData.email}
          onChange={(event) =>
            setFormData({ ...formData, email: event.target.value })
          }
          className="valhalla-input"
          required
        />
      </FormField>

      <FormGrid>
        <FormField label={t("phone")}>
          <Input
            value={formData.phone}
            onChange={(event) =>
              setFormData({ ...formData, phone: event.target.value })
            }
            className="valhalla-input"
          />
        </FormField>
        <FormField label={t("taxId")}>
          <Input
            value={formData.tax_id}
            onChange={(event) =>
              setFormData({ ...formData, tax_id: event.target.value })
            }
            className="valhalla-input"
          />
        </FormField>
      </FormGrid>

      <FormField label={t("address")}>
        <Input
          value={formData.address}
          onChange={(event) =>
            setFormData({ ...formData, address: event.target.value })
          }
          className="valhalla-input"
        />
      </FormField>

      <FormField label={`${t("paymentTerms")} (days)`}>
        <Input
          type="number"
          value={formData.payment_terms}
          onChange={(event) =>
            setFormData({
              ...formData,
              payment_terms: parseInt(event.target.value, 10) || 30,
            })
          }
          className="valhalla-input"
        />
      </FormField>

      <div className="flex items-start gap-3 rounded-lg border border-[#242E42] bg-[#0B0E14]/60 p-3">
        <Checkbox
          id="has_tax_retention"
          checked={Boolean(formData.has_tax_retention)}
          onCheckedChange={(checked) =>
            setFormData({ ...formData, has_tax_retention: Boolean(checked) })
          }
          className="mt-1"
        />
        <label htmlFor="has_tax_retention" className="cursor-pointer">
          <span className="block text-sm font-medium text-[#F3F4F6]">
            Retención de impuestos
          </span>
          <span className="mt-1 block text-xs leading-5 text-[#9CA3AF]">
            Al facturar a este cliente, el ITBMS efectivo se reduce a la mitad.
          </span>
        </label>
      </div>

      <FormField label={t("notes")}>
        <Textarea
          value={formData.notes}
          onChange={(event) =>
            setFormData({ ...formData, notes: event.target.value })
          }
          className="valhalla-input"
        />
      </FormField>

      <FormActions
        cancelLabel={t("cancel")}
        submitLabel={t("save")}
        onCancel={onCancel}
        submitTestId="save-client-btn"
      />
    </form>
  );
}

export default ClientForm;
